import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
    theme: {
        primary: '#DB1238',
        secondary: '#1D2A39',
        success: '#AED51B',
        info: '#4879B2',
        warning: '#FFB822',
        danger: '#FF2B55',
        light: '#F8F9FA',
        dark: '#131C26',
        white: '#fff',
        accent: '#DB1238'
    },
    breakpoint: {
        thresholds: {
            md: 1440
        }
    }
})
